export default {"src":"/_next/static/media/notification-3-line 1.28c19357.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};